import { useState } from 'react';
import { ArrowForward, Visibility, VisibilityOff } from '@mui/icons-material';
import {
  Button,
  Grid,
  IconButton,
  InputAdornment,
  Link,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { useNavigate } from '@/hooks/use-navigation';

interface PasswordProps {
  identifier: string;
  onSubmit: (password: string) => void;
  error?: string;
  processing?: boolean;
}

export const Password = ({
  identifier,
  onSubmit,
  error,
  processing = false,
}: PasswordProps) => {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [localError, setLocalError] = useState<string | undefined>();

  const displayError = error || localError;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setLocalError(undefined);

    if (!password.trim()) {
      setLocalError('Senha é obrigatória');
      return;
    }

    onSubmit(password);
  };

  return (
    <>
      <Grid container direction="column" rowGap={1} mb={4}>
        <Typography variant="h3" fontWeight="normal">
          Olá, {identifier}
        </Typography>
      </Grid>
      <form onSubmit={handleSubmit}>
        <Stack direction="row" spacing={2} alignItems="flex-start" mb={1}>
          <TextField
            autoFocus
            type={showPassword ? 'text' : 'password'}
            placeholder="Digite sua senha"
            fullWidth
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            error={!!displayError}
            helperText={displayError}
            slotProps={{
              input: {
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label={`${showPassword ? 'Ocultar' : 'Mostrar'} senha`}
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              },
            }}
          />
          <Button
            sx={{ height: '100%' }}
            type="submit"
            variant="contained"
            disabled={processing}
          >
            <ArrowForward />
          </Button>
        </Stack>
        <Link onClick={() => navigate('/login/esqueci-minha-senha')}>
          Esqueci minha senha
        </Link>
      </form>
    </>
  );
};
